import {twMerge} from "tailwind-merge";

export default function SimpleTextarea({label = "", wordCount, rowLabel, classes = {}, ...otherProps}) {

    const {parentClasses = "", labelClasses = "", inputClasses = ""} = classes;

    return (
        <label className={twMerge(`relative ${rowLabel ? "xl:flex block" : ""}`, parentClasses)}>
            <p className={twMerge(`font-semibold text-sm text-pol-purple ${rowLabel ? "mb-2 mr-4 xl:ml-4 xl:mb-0 xl:mr-0" : "mb-2 mr-4"}`, labelClasses)}>{label}</p>
            <textarea
                className={twMerge("w-full rounded-[0.875rem] outline-none resize-none border border-pol-light-4 px-2.5 pt-4 pb-1 placeholder:text-sm placeholder:text-pol-purple-4 text-pol-dark duration-300 focus:border-pol-main-dark-color", inputClasses)} {...otherProps}>

            </textarea>
            {
                wordCount ?
                    <span
                        className="absolute bottom-4 left-3.5 pointer-events-none text-pol-purple font-semibold text-xs">{otherProps.value ? otherProps.value.length : "0"}/{wordCount}</span>
                    : null
            }
        </label>
    )
}
